const IMG = {
  iAm23: "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/hamlm0mi_i%20am%2023.png",
  simpleThings:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/k23dn9z4_Simple%20Things.png",
  dance:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/pxf4wmyf_first%20impule.png",
  cat: "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/wraqibpv_cat%20side%20eye.png",
  west: "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/xqt60669_the%20west.png",
  helloWorld:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/fbego5nz_hello%20world.png",
  fall: "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/fm65ov0y_sf%20bridge.png",
  bulls:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/24ewnt8k_all%20bulls%20go%20to%20heaven.png",
  somebody:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/zrtoxd8f_Somebody%21.png",
  tomorrow:
    "https://customer-assets-0z36b82j.emergentagent.net/job_023561b9-156c-43c6-bc8a-fbaf03c78ddc/artifacts/s2l46oza_Image%20ref%20.png",
  physics:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/7bsmglr7_not%20understanding%20physics.png",
  laughter:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/q5on1rp8_Laughter%20and%20Insight.png",
  television:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/2jj3cvy7_image.png",
  lines: "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/zs3n444e_Lines.png",
  twentyTwenty:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/vq1q5wmu_2020.png",
  ego: "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/s2hv0nic_My%20enormous%20ego.png",
  mediation:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/dlezj3h2_Mediation.png",
  eyesWideOpen:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/kxvg3g5l_Eyes%20Wide%20Open.png",
  egypt: "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/9c362l5d_egypto.png",
  science:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/70t8c8cj_sciencepng.png",
  absolutely:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_lyric-canvas-9/artifacts/zxxjayvt_coloredversion.png",
};

// Newest first. `shards` is the ordered fragmentation of the photograph.
export const poems = [
  {
    id: "i-am-23",
    title: "I Am 23",
    date: "October 2024",
    image: IMG.iAm23,
    shards: [
      ["To avoid the drama", "I will say this:"],
      ["I am dissolved", "in the concrete", "whorls, kisses, fat rolls"],
      ["The chewing gum", "Juiced of its mints", "Is stomped into me"],
      ["I could always lie", "And say we met", "In Argentina"],
      ["'love came by night", "a cinema about it,"],
      ["Great leading man", "it got really good", "at the good bits,"],
      ["And it was like", "the boring bits were there", "for pacing'"],
      ["You know, right", "you'll never find", "anyone like me?"],
      ["I said", "'Right back at you, bitch'"],
    ],
  },
  {
    id: "simple-things",
    title: "Simple Things",
    date: "September 2024",
    image: IMG.simpleThings,
    shards: [
      ["I say"],
      ["'It's all about", "not capitulating'"],
      ["He responds", "'I don't know the enemy'"],
      ["I tell him", "'Don't be out-deluded'"],
      ["He asks", "'Why?'"],
      ["I respond", "'There is a danger", "of being devoured'"],
      ["He thinks", "'But the dream", "must grip me'"],
      ["I say", "'The dream is the medium'"],
      ["He sighs", "'We are too far from home'"],
    ],
  },
  {
    id: "first-impulse",
    title: "My First Impulse Is To Dance",
    date: "September 2024",
    image: IMG.dance,
    shards: [
      ["I could not have been an actor", "Despite my need", "for validation"],
      ["It should not come from you,", "you TV audience Nielsen"],
      ["With your palette of vanilla", "And mind of toast"],
      ["So I seek riches", "(for Agency),"],
      ["To ask the question", "and to answer it", "ahead of time"],
      ["Lies! Well, partly lies", "I'm mostly interested in", "Meaningful vanity"],
      ["That is to say:", "My Children,"],
      ["which is to say,", "Their mother,"],
      ["which is to say", "What are you doing on Friday", "next Friday?"],
    ],
  },
  {
    id: "as-a-cat",
    title: "As A Cat",
    date: "August 2024",
    image: IMG.cat,
    shards: [
      ["I would roam", "the streets", "in the dark"],
      ["Indulging", "the gutter", "and the attic"],
      ["And between them", "Robbing open windows", "of their singing birds"],
      ["Yawns beyond the", "street lamps", "Careful still"],
      ["eyes half open", "because If they were closed"],
      ["The other cats", "Would gouge them"],
      ["There would be", "pleasure", "In scraps and Milk"],
      ["The mothering", "midnight air", "would close in"],
      ["tenderly now", "Sleep would come"],
    ],
  },
  {
    id: "the-west",
    title: "The West",
    date: "August 2024",
    image: IMG.west,
    shards: [
      ["The smoke over there"],
      ["Is a wildfire"],
      ["Don't worry", "It can't come over"],
      ["The terrain will strangle it;"],
      ["unbroken horses", "are borne to yield"],
      ["By a natural choke"],
      ["—Shhhh shhh shh,", "trust me"],
      ["Smoke and cloud", "lather the hills"],
      ["As Christ did in 1884", "in Jackson, Wyoming."],
    ],
  },
  {
    id: "hello-world",
    title: "Hello World",
    date: "July 2024",
    image: IMG.helloWorld,
    shards: [
      ["Oh my name?", "Ahab's Ahab"],
      ["I'm having trouble", "with my story"],
      ["But I have tracked", "his movement", "To the Bikini"],
      ["Are you with me men?"],
      ["Soon"],
      ["I float on the coffin", "of the Native", "All for what was said", "about the doubloon"],
      ["But here", "For you,", "Let me say out-loud", "the un-pretended bit:"],
      ["Sir I am Blind", "Sir I seek riches", "Sir I would kill for a siren"],
      ["And in that moment", "God spake unto the whale,", "And the whale breached", "into the Sun"],
    ],
  },
  {
    id: "twenty-twenty",
    title: "20-20",
    date: "June 2024",
    image: IMG.twentyTwenty,
    shards: [
      [
        "We can all agree on acts of God",
        "such as the discovery",
        "of the highland spring",
        "that produces Coca-Cola,",
      ],
      ["and Fridays,", "both Good and Black;", "so, what is a blessing?"],
      [
        "I mean what REALLY",
        "is a blessing?",
        "A blessing is in truth",
        "a sublime act of beneficence",
        "from which I stand to make",
        "a non taxable capital gain.",
      ],
      [
        "Why does it wear a disguise?",
        "To defer, to allow",
        "the interstice, to seduce.",
      ],
      [
        "This window is the blind,",
        "unspecified water within which",
        "the Sargasso Eel",
        "will form a trace.",
        "No one has ever seen",
        "the Sargasso Eel reproduce",
        "in the wild before.",
      ],
      [
        "The trace will loop its tail",
        "and eat it as",
        "the Original vitamin.",
      ],
      [
        "You exclaim at the site",
        "of this gentle decapitation:",
        "\u201cAha!\u201d causing the Kool Aid",
        "to surge upward and outward",
        "in vomitous parabola.",
      ],
      [
        "Blond wigs and fake mustaches",
        "conceal blonde mustaches",
        "and full heads of hair.",
        "Two boys, one on",
        "the other's shoulders,",
        "under a trench-coat",
        "wear a fedora",
      ],
      [
        "and ask the clerk to fill",
        "their bags in a low baritone.",
        "These prepubescent druids",
        "are protected by a natural magic,",
        "which requires as its",
        "ritual sacrifice the purchase",
        "of enchained moments.",
      ],
    ],
  },
  {
    id: "the-fall",
    title: "The Fall",
    date: "May 2024",
    image: IMG.fall,
    shards: [
      ["In August last year", "your voice was warmth."],
      ["In your voice was August", "the year before then", "and the year before then."],
      ["Your touch was holy and", "your fibers were velcro"],
      ["Pain issues a", "constructive pathology:"],
      ["My mother collects virtue,", "my sister collects novelty,"],
      ["and I try to collect", "satisfying answer", "to the question", "of what I am worth."],
      [
        "My father collects",
        "empty houses.",
        "Older now,",
        "I know that",
        "you can never lose",
        "if you're in love.",
      ],
      [
        "You are still",
        "the strangest family.",
        "You see me best in the dark.",
        "So, the light causes sadness,",
        "and I buried my head",
        "in a pillow.",
      ],
      ["I can't have you.", "can you ask whoever can", "to take pictures?"],
    ],
  },
  {
    id: "all-bulls",
    title: "All Bulls Go To Heaven",
    date: "May 2024",
    image: IMG.bulls,
    shards: [
      ["There is no more", "stiff an upper lip", "than the upper lip", "of the matador."],
      ["The bull never", "stood a chance", "See, bulls do not eat meat."],
      ["To the bull, there is honor,", "pride, violence", "is ennobled by"],
      ["Tradition", "Centuries of other bulls", "raging; Persistance", "is in persisting."],
      ["Children fashion horns", "from their index fingers,"],
      [
        "They cheer the loudest when",
        "the matador makes",
        "a pathetic, drooling",
        "paraplegic of the bull.",
      ],
      [
        "A total of six bulls",
        "are killed during",
        "a bull fight.",
        "There are more efficient",
        "ways to kill a bull.",
      ],
      [
        "You could shoot him,",
        "you could inject him",
        "with cyanide,",
        "you could drop",
        "a piano on him.",
      ],
      ["But crowds are drawn", "when love is made."],
    ],
  },
  {
    id: "somebody",
    title: "Somebody!",
    date: "May 2024",
    image: IMG.somebody,
    shards: [
      ["And when did you", "become god?"],
      ["Now"],
      ["Will you marry me?"],
      ["No"],
      ["Is boredom the problem?"],
      ["Boredom is always", "the problem"],
      ["I am nothing yet", "to write home about"],
      ["But one day", "Home will write you"],
      ["About me"],
    ],
  },
  {
    id: "tomorrow",
    title: "Tomorrow",
    date: "May 2024",
    image: IMG.tomorrow,
    shards: [
      ["I'm excited to be middle aged.", "To be fat and ugly.", "Fatter and uglier."],
      [
        "In my mind, there is a villa:",
        "it is somewhere Mediterranean,",
        "I think perhaps Greece.",
        "I have never been to Greece.",
      ],
      [
        "In Corfu I strut",
        "collecting many beetles.",
        "I don't know",
        "anything about insects",
      ],
      ["I have tomatoes", "and will die", "of a heart attack"],
      ["with an orange peel", "that substitutes front teeth"],
      ["I've killed some bad men", "and some good men"],
      ["There is a wife who loves me", "She's perfect!"],
      ["I don't smoke now", "but she and I smoke together."],
      ["We read fictional books", "About the real world"],
    ],
  },
  {
    id: "eyes-wide-open",
    title: "Eyes Wide Open",
    date: "February 2024",
    image: IMG.eyesWideOpen,
    shards: [
      [
        "This morning I summoned",
        "a black hole",
        "in the subway station",
        "on (under?) Third Avenue.",
      ],
      [
        "The woman next to me",
        "did not take notice.",
        "Her attention was drawn",
        "to the corporate meridian",
        "that beamed publicly",
        "from her screen.",
      ],
      [
        "But I had no choice.",
        "I sat there staring",
        "as it bled my edges",
        "into blunt serrations",
      ],
      ["Folding my toothless gums", "into an attitude of prayer"],
      ["mmm mmm mmm"],
      [
        "It mumbled under its own weight,",
        "electrons gossiping",
        "in static hums,",
        "Delivering what I understood",
        "to be the first gospelized",
        "account of mathematics.",
      ],
      [
        "Still, the woman did not notice.",
        "Did she know that there was",
        "a Soviet astronaut stranded",
        "in space, Sergei, in space,",
        "stranded, for 311 days",
        "when the USSR collapsed?",
        "He and I have a common",
        "understanding of prolonged absence.",
      ],
      [
        "In these evening wastelands,",
        "I lost the underlying principle",
        "that tethered me to mission control.",
        "I saw only eschewed derivatives",
        "of ground truths:",
        "Little Things Make Big Days\u2014",
        "Never Stop Learning Because",
        "Life Never Stops Teaching\u2014",
        "All Things Are Difficult",
        "Before They Are Easy.",
      ],
      [
        "Dollar store wisdom",
        "tattooed on laser-cut sheets",
        "of polylactic acid",
        "has replaced the bloody",
        "inscriptions of the long line",
        "of lion-hearted cowards",
        "from which I come.",
      ],
    ],
  },
  {
    id: "physics",
    title: "Not Understanding Physics",
    date: "November 2023",
    image: IMG.physics,
    shards: [
      ["Of the natural structures,", "Synecdoche was always", "my favorite."],
      ["Not only because", "it sounded funny"],
      ["and its correct pronunciation", "Marked me as less Indian"],
      ["But also because its shortcut", "enfeebled me in time."],
      ["Why cross a border", "when the border", "Viewed at a distance", "safe enough can", "Offer you the whole?"],
      ["This is how I reconcile", "most things", "I do not understand."],
      [
        "It is why I have",
        "convinced myself",
        "that grasping boundaries",
        "Is worth more than",
        "what is contained",
        "within them.",
      ],
      ["It is the thought", "that allows me to sleep;"],
      ["If I collect enough maps,", "I will see the world."],
    ],
  },
  {
    id: "laughter-and-insight",
    title: "Laughter And Insight",
    date: "October 2023",
    image: IMG.laughter,
    shards: [
      ["Possibility is freezing.", "The make-your-nipples-hard", "kind of cold."],
      [
        "I am desiccated and gaunt",
        "Polyurethane collecting",
        "in cakes of skin.",
        "Snaking, Delicious.",
        "Cookies and cream.",
      ],
      [
        "I want to be silently minimized;",
        "in shushes and insults to",
        "the smallest reducible",
        "anthropic point:",
        "the eye of an i",
      ],
      ["the dot above the staff,", "cusping on deletion."],
      ["Darling, I will never", "say goodbye."],
      [
        "Dashed is the urge to write.",
        "To language, to story,",
        "to tell my grandkids.",
        "Observation is blindness.",
        "The self-reflex is an",
        "evolutionary vestige.",
      ],
      [
        "I will read this in four months",
        "and declare:",
        "\u201cDear Kalsi,\u201d I will write,",
        "\u201cDear Kalsi,",
        "You pretentious hack,\u201d",
        "I will say, \u201cDear Kalsi\u201d",
      ],
      [
        "I break lines in this poem: I",
        "destroy paragraphs.",
        "I murder the meter.",
        "I burn rhythm like it's chrome.",
      ],
      [
        "Impatience perfumes the room",
        "and white space produces",
        "terror in sounds.",
        "It's trash, dear Kalsi,",
        "earth to Kalsi, it's all trash.",
        "It smells like bananas.",
        "This is my life.",
        "I am only as much as I can see.",
        "My eyes were long ago",
        "stolen by a bird.",
      ],
    ],
  },
  {
    id: "television-movies",
    title: "Television Movies",
    date: "October 2023",
    image: IMG.television,
    shards: [
      [
        "My sister was always at school",
        "or in pursuit",
        "of some heavy goal",
        "thrust upon her",
        "in liminal faith.",
      ],
      ["Lead burrowing", "into the temple,", "A worm.", "An obligate parasite."],
      [
        "I was told that language is an",
        "Appendage of love.",
        "Love replicates",
        "in algal balloons,",
        "in Hysteria, where",
        "the asymptote meets the shore",
      ],
      [
        "Absence is the most",
        "immediate tragedy",
        "since it is too much",
        "and too little",
      ],
      [
        "Dragging slippers",
        "\u2014or some Streetcar,",
        "or Indira Gandhi's government,",
        "or sin waves\u2014",
      ],
      ["All settled in a messy nest", "outside her bathroom door."],
      [
        "I would watch made-for-TV movies",
        "for the Chinese Mainland",
        "On Sundays when she was",
        "on the couch next to me,",
        "but somehow elsewhere",
      ],
      [
        "A red hug would find me dirty",
        "and comfortable",
        "in my walled garden",
        "My whole world bound",
        "by stone clouds;",
        "Guidable by a dachshund",
        "Its size, I am recognizing,",
        "was an oxygen",
      ],
      [
        "But who asked her nakedly",
        "about hers?",
        "Who knew the contours",
        "of her sublime republic?",
        "The one that she kept",
        "squirreled away",
        "Under rubber-tree leaves",
        "I hope that asking now",
        "is still enough",
      ],
    ],
  },
  {
    id: "enormous-ego",
    title: "My Enormous Ego",
    date: "August 2023",
    image: IMG.ego,
    shards: [
      [
        "What do you see",
        "when you look upon a statue",
        "Romanesque, pristine, frozen;",
        "brined in antiquity",
        "If not the future?",
      ],
      ["I had words once", "with Alexander", "At Opis no less.", "He compelled me to the sword."],
      [
        "I spoke but one time",
        "with Washington.",
        "A dialogue that shrunk me",
        "at Yorktown",
        "Under the sheer scale",
        "of the free idea.",
      ],
      ["I danced three years ago", "with Napoleon", "In a tent outside Waterloo\u2014"],
      ["He whispered in flirtation:", "\u201cA true man hates no one.\u201d"],
      ["Words are yet to prove enough.", "These men are neither friends", "Nor my father."],
      [
        "Tomorrow, I will speak with",
        "Schopenhauer, Von Neumann",
        "and Madame Curie;",
      ],
      [
        "They will make it obvious,",
        "politely,",
        "that I do not have the mettle",
        "To fit amongst them",
      ],
      [
        "But the day after that",
        "I will bleed to build",
        "an unhumble home",
        "I will endeavor to insight",
        "I will bang my fist",
        "on that same table",
        "To which these men are sworn",
      ],
    ],
  },
  {
    id: "lines",
    title: "Lines",
    date: "June 2023",
    image: IMG.lines,
    shards: [
      [
        "From a distance the train",
        "looks like color-coded",
        "optimism.",
        "Vermillion and white.",
        "Japanese.",
      ],
      [
        "Shrine gates wear",
        "Vermillion and mercury",
        "because the poison",
        "keeps out the rot",
        "and the insects.",
      ],
      ["At the passing stations", "the moths hold parliament", "with the light."],
      [
        "A moth steers by keeping",
        "the moon at one angle.",
        "Any light close enough",
        "becomes the moon.",
      ],
      [
        "I could not have resisted",
        "these new LEDs myself.",
        "their bodies are ground",
        "into the platform",
      ],
      [
        "as first attempt at candyfloss",
        "with pink coming later,",
        "to make it palatable",
        "for the children",
      ],
      [
        "The other passengers",
        "are busier than me",
        "and more in love!",
        "SO in love!",
        "Its Nauseating!",
        "Such perfect strangers.",
      ],
      [
        "Who come by their perfection",
        "by the instruction of my own",
        "inadequacy; gods cast from,",
        "the red alloy of self doubt",
      ],
      [
        "My friend who I am going to see",
        "Who loves me so",
        "but she may fear drudged in",
        "moth marks on her",
        "New Haven carpet",
        "so maybe she will ask",
        "for my shoes at her door",
        "But I wouldn't know",
        "The train goes back",
        "to Grand Central",
        "if you just stay on it",
        "long enough.",
      ],
    ],
  },
  {
    id: "egypt",
    title: "Egypt",
    date: "May 2023",
    image: IMG.egypt,
    shards: [
      ["You feel like Egypt", "That time I went", "with my cousins", "when I was 8,"],
      [
        "We stayed next to",
        "the stumble reef",
        "miles from Cairo,",
        "And we snorkeled",
        "for hours and hours.",
      ],
      ["Those days were", "lived comfortably", "My grandmother was young"],
      [
        "She had jet black hair",
        "and the ability to travel",
        "My mother still",
        "spoke to Reenie,",
        "And we were still friends",
        "with her kids",
      ],
      [
        "I'm not unhappy now;",
        "in fact I'm happy.",
        "I am taken too easily",
        "by thoughts about thoughts.",
      ],
      [
        "And goaded by the unfamiliar",
        "image of myself",
        "When I catch glimpses",
        "of him in",
        "Oblong mirrors.",
      ],
      [
        "Strange bastard",
        "in a collarless",
        "button down shirt.",
        "At least he is wearing",
        "Nile Cotton.",
      ],
      [
        "So you're Egypt, huh?",
        "Dust and ancient tombs?",
        "Conspiracy and magnetism?",
        "Flea markets and",
        "saltwater crocodiles?",
      ],
      [
        "I wonder if you remember",
        "that haircut I gave myself.",
        "Because I don't think you do,",
        "You weren't there.",
      ],
    ],
  },
  {
    id: "absolutely",
    title: "Absolutely And Without A Doubt",
    date: "April 2023",
    image: IMG.absolutely,
    shards: [
      ["Bracket-unbracketed."],
      ["Ratch, unratcheted."],
      ["Tyrants, placenta,", "mannequins,", "Lana Del Rey."],
      [],
      ["All are of the heavy sky."],
      [],
      ["The game atremble:"],
      ["my hands steady"],
      [],
    ],
  },
  {
    id: "science",
    title: "Science",
    date: "March 2023",
    image: IMG.science,
    shards: [
      ["On your altar I lay", "this ancestral computer."],
      ["My gloves stain", "since I am allergic to ethanol."],
      ["Be the secular enzyme"],
      ["and Make whole", "the humble substrate."],
      ["Seduce me with a certainty."],
      ["Swaddle me with a center."],
      ["Swallow me like I'm calcium."],
      [
        "Give me always-never",
        "as a well-formatted table.",
        "Space in the margins,",
        "two indentations",
      ],
      [
        "The furthest I shall go from home",
        "is to repair the orbiting",
        "satellites and no more.",
      ],
    ],
  },
  {
    id: "mediation",
    title: "Mediation",
    date: "March 2023",
    image: IMG.mediation,
    shards: [
      ["Last night I had to abandon", "the giddy vanity of words."],
      ["I did it with the taste", "of red spit in my mouth"],
      ["And the words re-sounded,", "no longer necessary", "to their meaning"],
      ["Experience is", "a regional dialect"],
      ["loosely derived", "from cave paintings"],
      ["and monuments", "of twig and vine."],
      ["So we pass each other as", "Unknowing children"],
      ["from a stone-age", "Without an alphabet"],
      ["or a hieroglyph", "between us"],
    ],
  },
];
